module.exports = __webpack_public_path__ + "img/home.3908d12d.png";